import React from "react";
import styled, { withTheme } from "styled-components";

const StyledButton = styled.button`
  color: ${(props) => props.theme?.black};
  background-color: ${(props) => props.theme?.white};
  max-height: 75px;
  text-align: justify;
  font-weight: 600;

  :hover {
    color: #fff;
    background-color: ${(props) => props.theme?.darkPurple};
    border-color: ${(props) => props.theme?.darkPurple};

    span {
      background-color: ${(props) => props.theme?.white};
      border-color: ${(props) => props.theme?.white};
      color: ${(props) => props.theme?.darkPurple};
    }
  }

  :focus {
    box-shadow: 0 0 0 0.2rem rgba(167, 32, 140, 0.5);
  }

  .btn-content {
    align-items: center;
    height: 40px;
    justify-content: space-between;
  }
`;

const StyledBadge = styled.span`
  border: 5px solid ${(props) => props.theme?.darkPurple};
  background-color: ${(props) => props.theme?.darkPurple};
  border-radius: 2px;
  color: ${(props) => props.theme?.white};
  font-size: 0.65rem;
`;

const BadgeButton = (props) => {
  const { id, text, onClick } = props;

  return (
    <div
      className="row"
      id={id ? `${id}-div` : "badge-default-id-div"}
      onClick={() => onClick()}
    >
      <StyledButton
        id={id ? `${id}-btn` : "default-badge-btn-id"}
        className="btn "
      >
        <div className="row btn-content">
          <div>{text}</div>
          <div>
            <StyledBadge className="fas fa-plus fa-xs" />
          </div>
        </div>
      </StyledButton>
    </div>
  );
};

export default withTheme(BadgeButton);
